import Page from 'src/apipages/libraries/examples/index';

export default Page;
